import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Home|Dashboard|Appointments|`;

export type CpAppointmentCardLoc =
	| 'CPDashboardAppointmentsCardLabelDate'
	| 'CPDashboardAppointmentsCardContentEdit'
	| 'CPDashboardAppointmentsCardButtonReschedule'
	| 'CPDashboardAppointmentsCardButtonCancel';

export const appointmentCardLocs: LocDefs<CpAppointmentCardLoc> = {
	CPDashboardAppointmentsCardLabelDate: {
		defaultValue: 'Appointment Date',
		description: 'Label for date',
		displayPath: `${dpRoot}|Date`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentsCardContentEdit: {
		defaultValue: 'Edit Appointment',
		description: 'Tooltip for edit button',
		displayPath: `${dpRoot}|Edit Content`,
		displayType: 'Label',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentsCardButtonReschedule: {
		defaultValue: 'Reschedule',
		description: 'Tooltip for reschedule button',
		displayPath: `${dpRoot}|Reschedule`,
		displayType: 'Button',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
	CPDashboardAppointmentsCardButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Tooltip for cancel button',
		displayPath: `${dpRoot}|Cancel`,
		displayType: 'Button',
		feature: HubFeature.ExamAppointmentsExamAppointmentsDashboardUpcomingAppointments,
		htmlAllowed: false,
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CpAppointmentCardLoc>(appointmentCardLocs);
export type CpAppointmentCardLocKeys = LocMap<CpAppointmentCardLoc>;
